import ROLE from "@/common/ROLE";
import guardService from "@/services/auth/guard.service";
import AdministratorVue from "@/views/modules/administrator/Administrator.vue";
import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";
const HomeViewVue = () => import("../views/HomeView.vue");
// import administratorRoutes from "../router/administator.router";
import quantriRoutes from "./quantri.route";
import deviceService from "@/services/auth/device.service";
import authService from "@/services/auth/auth.service";
Vue.use(VueRouter);

const router = new VueRouter({
	mode: "history",
	base: "/",
	scrollBehavior(to) {
		if (to.hash) {
			return {
				selector: to.hash,
				behavior: "smooth",
			};
		}
	},
	routes: [
		// Add a catch-all non-existence route to redirect to main path
		{
			path: "*",
			redirect: () => {
				const data = {
					error: "workflow.notFound",
				};
				return {
					name: "unauthorized-redirect",
					params: {
						data: data,
					},
				};
			},
		},
		{
			path: "/login",
			name: "login",
			component: () => import("../views/modules/auth/sign-in.vue"),
			meta: {
				title: "Login",
				requiresAuth: false,
			},
		},
		{
			path: "/unauthorized-redirect",
			name: "unauthorized-redirect",
			component: () => import("../views/modules/auth/unauthorized.vue"),
			meta: {
				title: "Unauthorized",
				requiresAuth: false,
			},
		},
		// DEPRECATED
		// {
		// 	path: "/administrator",
		// 	name: "Trang quản lý",
		// 	component: AdministratorVue,
		// 	meta: {
		// 		requiresAuth: true,
		// 		roles: [ROLE.ROLE_ADMINISTRATOR],
		// 	},
		// 	children: administratorRoutes,
		// },
		{
			path: "/quan-tri",
			name: "Trang quản trị",
			component: AdministratorVue,
			meta: {
				template: true,
				requiresAuth: true,
				roles: [ROLE.ROLE_ADMINISTRATOR],
			},
			children: quantriRoutes,
		},
		{
			path: "/",
			component: HomeViewVue,
			meta: {
				title: "Smart Office Workflow",
				template: true,
				requiresAuth: true,
				roles: [ROLE.ROLE_USER, ROLE.ROLE_ADMINISTRATOR],
			},
			children: [
				{
					path: "",
					name: "Dashboard",
					component: () =>
						import(
							"../views/modules/administrator/Dashboard/DashboardEoffice2.vue"
						),
					meta: {
						requiresAuth: true,
						roles: [ROLE.ROLE_USER],
					},
				},
				{
					path: "report",
					name: "Báo cáo- Thống kê",
					component: () =>
						import(
							"../views/modules/administrator/Report/Report.vue"
						),
					meta: {
						requiresAuth: true,
						roles: [ROLE.ROLE_USER],
					},
				},
				{
					path: "report2",
					name: "Biểu đồ thống kê",
					component: () =>
						import(
							"../views/modules/administrator/Report2/Report.vue"
						),
					meta: {
						requiresAuth: true,
						roles: [ROLE.ROLE_USER],
					},
				},

				{
					path: "quy-trinh-lap",
					name: "Quy trình lặp",
					component: () =>
						import(
							"../views/modules/administrator/ProcessRepeat/ListProcessRepeat.vue"
						),
					meta: {
						requiresAuth: true,
						roles: [ROLE.ROLE_USER],
					},
				},
				{
					path: "bao-cao",
					name: "Báo cáo",
					component: () =>
						import(
							"@/views/modules/administrator/BaoCao/TemplateBaoCao"
						),
					meta: {
						template: true,
						requiresAuth: true,
						roles: [ROLE.ROLE_USER],
					},
					children: [
												{
							path: "he-thong",
							name: "Báo cáo hệ thống",

							component: () =>
								import(
									"@/views/modules/administrator/BaoCao/BaoCaoHeThong.vue"
								),
							meta: {
								template: true,
								requiresAuth: true,
								roles: [
									ROLE.ROLE_ADMINISTRATOR,
									ROLE.ROLE_ADMINDONVI,
								],
							},
						},
						{
							path: "qua-han",
							name: "Báo cáo phiếu yêu cầu quá hạn",

							component: () =>
								import(
									"@/views/modules/administrator/BaoCao/BaoCaoQuaHan.vue"
								),
							meta: {
								requiresAuth: true,
								roles: [ROLE.ROLE_USER],
							},
						},
						{
							path: "sap-het-han-den-han",
							name: "Báo cáo phiếu yêu cầu sắp hết hạn, đến hạn",

							component: () =>
								import(
									"@/views/modules/administrator/BaoCao/BaoCaoSapHetHanDenHan.vue"
								),
							meta: {
								requiresAuth: true,
								roles: [ROLE.ROLE_USER],
							},
						},
						{
							path: "sap-het-han-den-han",
							name: "Báo cáo phiếu yêu cầu sắp hết hạn, đến hạn",

							component: () =>
								import(
									"@/views/modules/administrator/BaoCao/BaoCaoSapHetHanDenHan.vue"
								),
							meta: {
								requiresAuth: true,
								roles: [ROLE.ROLE_USER],
							},
						},
						{
							path: "tong-hop",
							name: "Báo cáo tổng hợp phiếu yêu cầu",

							component: () =>
								import(
									"@/views/modules/administrator/BaoCao/BaoCaoTongHop.vue"
								),
							meta: {
								requiresAuth: true,
								roles: [ROLE.ROLE_USER],
							},
						},
						{
							path: "tuy-chinh",
							name: "Báo cáo tùy chỉnh loại yêu cầu",

							component: () =>
								import(
									"@/views/modules/administrator/BaoCao/BaoCaoTuyChinh.vue"
								),
							meta: {
								requiresAuth: true,
								roles: [ROLE.ROLE_USER],
							},
						},
						{
							path: "chi-tiet-tong-hop",
							name: "Chi tiết tổng hợp",

							component: () =>
								import(
									"@/views/modules/administrator/BaoCao/ChiTietBaoCaoTongHop.vue"
								),
							meta: {
								requiresAuth: true,
								roles: [ROLE.ROLE_USER],
							},
						},
						{
							path: "chi-tiet-bao-cao-tuy-chinh",
							name: "Chi tiết báo cáo tùy chỉnh",

							component: () =>
								import(
									"@/views/modules/administrator/BaoCao/ChiTietBaoCaoTuyChinh.vue"
								),
							meta: {
								requiresAuth: true,
								roles: [ROLE.ROLE_USER],
							},
						},
						{
							path: "chi-tiet-phieu/:id",
							name: "Báo cáo - Chi tiết phiếu",

							component: () =>
								import(
									"@/views/modules/administrator/BaoCao/BaoCaoViewChiTietPhieu.vue"
								),
						},
					],
				},
				{
					path: "danh-sach-phieu-yeu-cau",
					name: "Danh sách phiếu yêu cầu",
					meta: {
						template: true,
						requiresAuth: true,
						roles: [ROLE.ROLE_USER],
					},
					component: () =>
						import(
							"@/views/modules/khai-phieu-yeu-cau/ListRequest/ListRequestIndex"
						),
					children: [
						{
							path: "can-xu-ly",
							name: "Phiếu yêu cầu cần xử lý",

							component: () =>
								import(
									"@/views/modules/khai-phieu-yeu-cau/ListRequest/ListRequestDataInProcess.vue"
								),
							meta: {
								requiresAuth: true,
								roles: [ROLE.ROLE_USER],
							},
						},
						{
							path: "chia-se",
							name: "Phiếu yêu cầu được chia sẻ",

							component: () =>
								import(
									"@/views/modules/khai-phieu-yeu-cau/ListRequest/ListRequestDataShared.vue"
								),
							meta: {
								requiresAuth: true,
								roles: [ROLE.ROLE_USER],
							},
						},
						{
							path: "dang-soan",
							name: "Phiếu đang soạn",

							component: () =>
								import(
									"@/views/modules/khai-phieu-yeu-cau/ListRequest/ListRequestDataDrafting.vue"
								),
							meta: {
								requiresAuth: true,
								roles: [ROLE.ROLE_USER],
							},
						},
						{
							path: "dang-theo-doi",
							name: "Phiếu đã xử lý",

							component: () =>
								import(
									"@/views/modules/khai-phieu-yeu-cau/ListRequest/ListRequestDataFollowing.vue"
								),
							meta: {
								requiresAuth: true,
								roles: [ROLE.ROLE_USER],
							},
						},
						{
							path: "da-hoan-thanh",
							name: "Phiếu đã hoàn thành",

							component: () =>
								import(
									"@/views/modules/khai-phieu-yeu-cau/ListRequest/ListRequestDataApproved.vue"
								),
							meta: {
								requiresAuth: true,
								roles: [ROLE.ROLE_USER],
							},
						},
						{
							path: "tu-choi",
							name: "Phiếu bị từ chối",

							component: () =>
								import(
									"@/views/modules/khai-phieu-yeu-cau/ListRequest/ListRequestDataGiveBack.vue"
								),
							meta: {
								requiresAuth: true,
								roles: [ROLE.ROLE_USER],
							},
						},
						{
							path: "cho-phe-duyet",
							name: "Phiếu chờ phê duyệt",

							component: () =>
								import(
									"@/views/modules/khai-phieu-yeu-cau/ListRequest/ListRequestDataWaitApproval.vue"
								),
							meta: {
								requiresAuth: true,
								roles: [ROLE.ROLE_USER],
							},
						},
					],
				},
				{
					path: "phieu-yeu-cau",
					// name: "Quản lý phiếu yêu cầu",
					meta: {
						template: true,
						requiresAuth: true,
						roles: [ROLE.ROLE_USER],
					},
					component: () =>
						import(
							"@/views/modules/khai-phieu-yeu-cau/RequestForm/RequestFormIndex"
						),

					children: [
						{
							path: ":id/xem-chi-tiet",
							name: "Chi tiết phiếu yêu cầu",
							component: () =>
								import(
									"@/views/modules/khai-phieu-yeu-cau/RequestForm/View/ViewRequest"
								),
							meta: {
								requiresAuth: true,
								roles: [ROLE.ROLE_USER],
							},
						},
						{
							path: "xem-chi-tiet/:id",
							name: "Chi tiết phiếu yêu cầu",
							redirect: ":id/xem-chi-tiet",
							meta: {
								requiresAuth: true,
								roles: [ROLE.ROLE_USER],
							},
						},
						{
							path: "chi-tiet-phieu-cho-phe-duyet/:id",
							name: "Chi tiết phiếu yêu cầu chờ phê duyệt",
							redirect: ":id/xem-chi-tiet",
							meta: {
								requiresAuth: true,
								roles: [ROLE.ROLE_USER],
							},
						},
						{
							path: ":id/chi-tiet",
							name: "Chỉnh sửa phiếu yêu cầu",
							component: () =>
								import(
									"@/views/modules/khai-phieu-yeu-cau/RequestForm/Draft/DraftRequest"
								),
							meta: {
								requiresAuth: true,
								roles: [ROLE.ROLE_USER],
							},
						},
						{
							path: ":id/phe-duyet",
							name: "Chi tiết phiếu yêu cầu cần phê duyệt",
							component: () =>
								import(
									"@/views/modules/khai-phieu-yeu-cau/RequestForm/Process/ProcessRequest"
								),
							meta: {
								requiresAuth: true,
								roles: [ROLE.ROLE_USER],
							},
						},
												// SSO V2 eoffice
						{
							path: ":id/chi-tiet-lich-su",
							name: "Trang lịch sử phê duyệt",
							component: () =>
								import(
									"../views/modules/khai-phieu-yeu-cau/HistoryProcedurePage/HistoryProcedurePage"
								),
							meta: {
								requiresAuth: false,
							},
						},
						// Backward support SSO V1 eoffice
						{
							path: ":id/chi-tiet-lich-su/:token",
							name: "Trang lịch sử phê duyệt",
							component: () =>
								import(
									"../views/modules/khai-phieu-yeu-cau/HistoryProcedurePage/HistoryProcedurePage"
								),
							meta: {
								requiresAuth: false,
							},
						},
						{
							path: ":id/tai-lieu/:attachmentId",
							name: "Chi tiết tài liệu",
							component: () =>
								import(
									"../views/modules/khai-phieu-yeu-cau/TaiLieu/ViewTaiLieu.vue"
								),
							meta: {
								requiresAuth: true,
								roles: [ROLE.ROLE_USER],
							},
						},
					],
				},
			],
		},
		{
			path: "/deep-link",
			component: () =>
				import("@/components/deep-link/DeepLinkMobileWrapper.vue"),
			meta: {
				title: "DeepLink",
				requiresAuth: false,
			},
			children: [
				{
					path: "open-app",
					name: "DeepLinkMobile",
					component: () =>
						import("@/components/deep-link/DeepLinkMobile.vue"),
				},
			],
		},
	],
});
router.beforeEach(async (to, from, next) => {
	if (!store.state.initialized) {
		// the store initialize will set initialized to true
		await store.dispatch("initialize");
	}
	// if user not logged in or the route is not public
	if (!guardService.canAccess(to)) {
		next({ name: "login" });
	} else {
		next();
	}
});

// Initialize store data
router.beforeEach(async (to, from, next) => {
	if (ignorePaths(to, from, next)) {
		return next();
	}
	if (authService.getAccessToken()) {
		if (!store.state.currentUserInfo) {
			await store.dispatch("getCurrentUserInfo");
		}
		if (!store.state.listStatus?.length) {
			await store.dispatch("getListStatus");
		}
	}
	next();
});

router.beforeEach(async (to, from, next) => {
	if (ignorePaths(to, from, next)) {
		return next();
	}
	if (!deviceService.getDeviceInfo()) {
		await deviceService.saveDeviceInfo();
	}
	const deviceInfo = deviceService.getDeviceInfo();
	if (
		// allow public route bypass deeplink && prevent path /deep-link loop
		to.meta.requiresAuth &&
		deviceInfo.deviceType === "Mobile Device" &&
		deviceInfo.deepLink
	) {
		return next({
			path: "/deep-link/open-app",
			query: { redirect: to.fullPath },
		});
	}
	next();
});

function ignorePaths(to) {
	// const ignoredList = ["login", "logout", "unauthorized", "not-found", "chi-tiet-lich-su"];
	return !to.meta.requiresAuth;
}

router.afterEach((to) => {
	Vue.nextTick(() => {
		document.title = to.name ?? "SmartOffice Workflow";
	});
});

router.onError((error) => {
	console.error("router.onError", error);
	// if (/loading chunk \d* failed./i.test(error.message)) {
	// 	// window.location.reload();
	// 	localStorage.clear();
	// }
});

export default router;
